import * as React from "react"
import * as style from "./style.module.css"
import ArticleList from "/src/components/ArticleList"
import BackgroundMedia from "/src/components/BackgroundMedia"
import BottomContact from "/src/components/BottomContact"
import Layout from "/src/components/Layout"
import MainButton from "/src/components/MainButton"
import Seo from "/src/components/Seo"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import mainViual from "/src/images/picture/mainvisual.png"
import aboutMedia from "/src/images/picture/IllustImg02-01.png"
import reasonMedia01 from "/src/images/picture/menu-main.jpg"

export function SimpleSlider() {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true, // スライドするためのスワイプを有効にする
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'linear',
    centerMode: true,
    centerPadding: '20px'
  }
  return (
    <Slider {...settings}>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
      <div className={style.slideImg}>
        <img src={reasonMedia01}/>
      </div>
    </Slider>

);
}

const Page = ({ pageContext }) => {

  const pageContent = {
    aboutText: "<span>高い提案力と対応力で\nお客様のグッズ制作をサポートします</span>\n\nSUNWAY（サンウェイ）は、オリジナルグッズの制作メーカーです。\nどのような製品を作るのかなどの企画・提案はもちろん、\n小ロットから大量ロットまでお客様のご要望に合わせ柔軟に対応させていただきます。",
    serviceText: "SUNWAY（サンウェイ）は、高品質で多様な製品制作はもちろん、企画・提案力を強みとしており\n静岡県・関東を中心に多くの企業さまにオリジナルグッズ制作をお任せいただいています。",
    serviceItems: [
      {
        titleJp: "製造可能な製品",
        titleEn: "Product",
        text: "高品質で多様な製品制作はもちろん、企画・提案力を強みとしております。",
        media: reasonMedia01,
        url: "https://www.sunway.co.jp/product"
      },
      {
        titleJp: "制作事例",
        titleEn: "Case Studies",
        text: "過去おつくりしたものを載せてます。",
        media: reasonMedia01,
        url: "https://www.sunway.co.jp/case"
      },
    ]
  }

  return (
    <Layout>
      <div className={style.top_visual}>
        <div className={style.top_visual_media_outer}>
          {/* <img src={pageContext.headMedial} alt="お客様のご要望をカタチに"/> */}
          <img src={mainViual} alt="お客様のご要望をカタチに"/>
        </div>
      </div>
      <section className={style.article_section}>
        <div className={style.section_heading}>
          <h2>記事</h2>
          <small>Article</small>
        </div>
        {pageContext.articles.length !== 0 ? (
          <>
            <div className={style.blog_items}>
              <ArticleList articles={pageContext.articles} />
            </div>
            <div className={style.more_btn}>
              <MainButton link={getPathFromTemplateType(4)} text="記事一覧はこちら" />
            </div>
          </>
        ) : (
          <div className={style.blog_textarea_empty}>
            <p>このブログにはまだ記事がありません。</p>
          </div>
        )}
      </section>
      <section className={style.about_section}>
        <div className={style.section_heading}>
          <h2>SUNWAYについて</h2>
          <small>About Us</small>
        </div>
        <div className={style.about_media}>
          {/* <img src={pageContext.aboutLargeMedia} /> */}
          <img src={aboutMedia} />
        </div>
        <div className={style.section_content}>
          <p className={style.section_description} 
            dangerouslySetInnerHTML={{
              __html: pageContent.aboutText,
            }}></p>
          <div className={style.more_btn}>
            <MainButton link={getPathFromTemplateType(2)} text="もっとみる" />
          </div>
        </div>
      </section>
      <section className={style.reason_section}>
        <div className={style.section_heading}>
          <h2>SUNWAYにお任せいただける理由</h2>
          <small>Motive</small>
        </div>
        <p className={style.section_description}>{pageContent.serviceText}</p>
        <SimpleSlider/>
        <div className={style.more_btn}>
          <MainButton link={getPathFromTemplateType(3)} text="もっとみる" />
        </div>
      </section>
      <section className={style.service_section}>
        <div className={style.section_heading}>
          <h2>わたしたちができること</h2>
          <small>Our Service</small>
        </div>
        {pageContent.serviceItems.map((service, index) => {
          return (
          <div className={style.service_item}>
            <div className={style.textBox}>
              <h3>{service.titleJp}<small>{service.titleEn}</small></h3>
              <p className={style.section_description}>{service.text}</p>
              <div className={style.more_btn}>
                <MainButton link={service.url} text="もっとみる" />
              </div>
            </div>
            <div className={style.photoBox}>
              <img src={service.media} alt=""/>
            </div>
          </div>
          )
        })}
      </section>
      <BottomContact />
    </Layout>
  )
}

export default Page

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />
}
